// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"KGfT5kSN"};